module.exports = new __parcel__URL__("Salome_Bakuradze.7bc409a8.jpg").toString();